import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { Waiting } from '../waiting/waiting';
import { RerunTask } from '../rerun-task/rerun-task';
import { UploadDocument } from '../upload-document/upload-document';
import { DocumentTypeEnum } from '../../_enums/document-type.enum';
import { DocumentService } from '../../_services/document.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WorkProcessSelector } from '../work-process-selector/work-process-selector';
import { WorkProcessWithClient } from '../../_models/social-domain/workprocess-with-client.model';

@Component({
  selector: 'app-check-decision',
  imports: [
    TranslateModule,
    MatButton,
    Waiting,
    RerunTask,
    UploadDocument,
    MatTooltipModule,
    WorkProcessSelector,
  ],
  templateUrl: './check-decision.html',
  styleUrl: './check-decision.scss',
})
export class CheckDecision implements OnInit, OnChanges {
  @ViewChild('uploadDocument') uploadDocument!: UploadDocument;
  @Input() checkDecisionError: boolean = false;
  @Input() checkedDecisionText: string | undefined;
  @Input() isCheckDecisionInProgress = false;
  @Input() isUploadInProgress = false;
  @Input() uploadDone = false;
  @Input() canUpload = false;

  @Input() preselectedWorkProcess: WorkProcessWithClient | null = null;
  @Output() public rerun = new EventEmitter<void>();
  @Output() public uploadToSsd = new EventEmitter<void>();
  @Output() public workProcessSelected = new EventEmitter<WorkProcessWithClient>();

  public decisionExists = false;
  public DocumentTypeEnum = DocumentTypeEnum;

  private isCheckUpToDate = false;

  get isCheckDisabled(): boolean {
    return !this.decisionExists || this.isCheckDecisionInProgress || this.isCheckUpToDate;
  }

  private readonly documentService = inject(DocumentService);

  public ngOnInit(): void {
    this.subscribeToDocumentChanges();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['checkedDecisionText'] && this.checkedDecisionText !== undefined) {
      this.isCheckUpToDate = true;
    }
  }

  public checkDecision(): void {
    this.documentService.setDocumentChanged(DocumentTypeEnum.DECISION, false);
    this.documentService.setOptionalDocumentsChanged(false);
    this.rerun.emit();
  }

  private subscribeToDocumentChanges(): void {
    this.documentService.getDocument(DocumentTypeEnum.DECISION).subscribe((file) => {
      this.decisionExists = !!file;
    });

    this.documentService.isDocumentChanged(DocumentTypeEnum.DECISION).subscribe((changed) => {
      if (changed) {
        this.documentService.setDocumentChanged(DocumentTypeEnum.DECISION, false);
        this.checkedDecisionText = undefined;
        this.checkDecisionError = false;
        this.isCheckUpToDate = false;
      }
    });

    this.documentService.isOptionalDocumentsChanged().subscribe((changed) => {
      if (changed) {
        this.isCheckUpToDate = false;
      }
    });
  }
}
